/* eslint-disable import/no-commonjs */
require('@sitepark/sp-base-js-api/dist/sp-base-js-api');
require('@sitepark/sitekit-js/src/main/javascript/Bootstrap');

// The dependency gate is active from Bootstrap's first scan, including its
// captured throttledBootstrap callback. Only this committed root is retried.
require('../modules/mapsight-hydration').onMapsightReady((root) => {
	SP.sitekit.Bootstrap.bootstrap(root);
});
